export default __webpack_public_path__ + "static/media/ITOPM-dark.f4d36d4e.svg";